import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteWebUrl } from '../hooks/useDeleteWebUrl';
import type { WebUrl } from '../types/webUrl.types';

interface WebUrlDeleteConfirmationProps {
  webUrl: WebUrl | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function WebUrlDeleteConfirmation({
  webUrl,
  open,
  onOpenChange,
}: WebUrlDeleteConfirmationProps) {
  const { mutate, isPending } = useDeleteWebUrl();

  function handleConfirm() {
    if (!webUrl) return;
    mutate(webUrl.id, { onSuccess: () => onOpenChange(false) });
  }

  const description = webUrl
    ? `"${webUrl.title ?? 'This URL'}" will stop being shown in the app. Set its status to Inactive instead if you want to keep it for later.`
    : '';

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete web URL?"
      description={description}
      confirmLabel="Delete"
      confirmVariant="destructive"
      isPending={isPending}
      pendingLabel="Deleting..."
      onConfirm={handleConfirm}
    />
  );
}
